const styles = theme => ({
    root: {
        padding: 0
    },
    appBar: {
        position: 'relative',
        marginBottom: theme.spacing(1)
    },
    flex: {
        flex: 1
    },
    contentRoot: {
        width: '100%',
        '@media (max-width: 768px)': {
            marginTop: theme.spacing(4)
        }
    },
    formElement: {
        marginBottom: 25 - theme.spacing(1)
    }
});

export default styles;